import {Component, Inject, Input} from 'ng-metadata/core';

const get= require('lodash/get');

@Component({
    "selector": "prm-brief-result-digital-best-offer",
    templateUrl: 'components/search/fullView/ngrs/ngrsBriefResultLine/briefResultDigitalBestOffer/briefResultDigitalBestOffer.html'
})

export class PrmBriefResultDigitalBestOffer{

    @Input() item:Object;
    @Input() private digitalSupplyTime: number ;

    @Input() private opendigitalform: Object;
    @Input() private openphysicalform: Object;

    constructor (){

    }

    ngOnInit(){
    }


    public getDigitalSupplyTime(){
        return this.digitalSupplyTime;
    }

    public isDigitalOfferFound(){
        // return true;
        return this.digitalSupplyTime > 0;
    }

    public showFormOnClick(event){
        this.openphysicalform.openPhysicalForm = false;
        this.opendigitalform.openDigitalForm = true;
        event.preventDefault();
        event.stopPropagation(); 
    }

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/ngrsBriefResultLine/briefResultDigitalBestOffer/briefResultDigitalBestOffer.directive.ts